import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

const CookiePolicy: React.FC = () => {
  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="Cookie Policy — CodeRom"
        description="How CodeRom uses cookies, including the cookie_consent preference."
      />
      <Navbar />

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 20px 60px'
      }}>
        {/* Breadcrumb */}
        <div style={{ marginBottom: '24px', fontSize: '14px' }}>
          <Link to="/" style={{ color: '#6366f1', textDecoration: 'none' }}>Home</Link>
          <span style={{ margin: '0 8px', color: '#9ca3af' }}>›</span>
          <span style={{ color: '#6b7280' }}>Cookie Policy</span>
        </div>

        {/* Başlık kartı */}
        <div style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
          borderRadius: '16px',
          padding: '40px',
          marginBottom: '32px',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, margin: '0 0 8px' }}>Cookie Policy</h1>
          <p style={{ fontSize: '14px', opacity: 0.8, margin: 0 }}>Last updated: April 2026 · Enerfix Limited</p>
        </div>

        {/* Ana içerik kartı */}
        <div style={{
          background: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '40px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>

          {/* Section 1 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: 0,
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              1. What are cookies?
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Cookies are small text files placed on your device when you visit our website. They help us provide
              you with a better experience by remembering your preferences and keeping you logged in.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              2. Cookies we use
            </h2>

            <div style={{
              overflowX: 'auto',
              margin: '20px 0',
              borderRadius: '12px',
              border: '1px solid #e5e7eb'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Cookie</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Type</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Purpose</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>session_id</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Essential</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Keeps you logged in</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Session</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>csrf_token</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Essential</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Security protection</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Session</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>auth_token</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Essential</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Authentication</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>7 days</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>cookie_consent</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Essential</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Remembers your cookie preference</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>1 year</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>_ga</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dbeafe', color: '#1e40af', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Analytics</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Google Analytics — tracks site usage</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>2 years</td>
                  </tr>
                  <tr style={{ background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontFamily: 'monospace' }}>_gid</td>
                    <td style={{ padding: '12px 16px' }}><span style={{ background: '#dbeafe', color: '#1e40af', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>Analytics</span></td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Google Analytics — distinguishes users</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>24 hours</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 3 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              3. Types of cookies
            </h2>

            <div style={{
              background: '#dcfce7',
              borderLeft: '4px solid #16a34a',
              borderRadius: '0 12px 12px 0',
              padding: '20px',
              margin: '20px 0'
            }}>
              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#166534', margin: '0 0 8px' }}>Essential cookies</h3>
              <p style={{ color: '#166534', fontSize: '14px', margin: 0, lineHeight: '1.7' }}>
                Required for the platform to function. You cannot opt out of these. Without essential cookies,
                you would not be able to log in or use Coderom's core features.
              </p>
            </div>

            <div style={{
              background: '#dbeafe',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '20px',
              margin: '20px 0'
            }}>
              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#1e40af', margin: '0 0 8px' }}>Analytics cookies</h3>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0, lineHeight: '1.7' }}>
                Help us understand how you use our platform. These cookies collect information about which pages
                you visit, how long you spend on each page, and any errors you encounter. You can opt out of these.
              </p>
            </div>

            <div style={{
              background: '#f3f4f6',
              borderLeft: '4px solid #6b7280',
              borderRadius: '0 12px 12px 0',
              padding: '20px',
              margin: '20px 0'
            }}>
              <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#374151', margin: '0 0 8px' }}>Marketing cookies</h3>
              <p style={{ color: '#374151', fontSize: '14px', margin: 0, lineHeight: '1.7' }}>
                We do not currently use marketing or advertising cookies on our platform.
              </p>
            </div>
          </div>

          {/* Section 4 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              4. Managing cookies
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              You can control cookies through your browser settings:
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', margin: '20px 0' }}>
              {[
                { browser: 'Chrome', path: 'Settings → Privacy and Security → Cookies' },
                { browser: 'Firefox', path: 'Settings → Privacy & Security → Cookies' },
                { browser: 'Safari', path: 'Preferences → Privacy → Cookies' },
                { browser: 'Edge', path: 'Settings → Cookies and site permissions' }
              ].map((item, index) => (
                <div key={index} style={{
                  background: '#f8fafc',
                  border: '1px solid #e5e7eb',
                  borderRadius: '12px',
                  padding: '16px',
                  textAlign: 'center'
                }}>
                  <h4 style={{ fontSize: '16px', fontWeight: 600, color: '#1e1b4b', margin: '0 0 8px' }}>{item.browser}</h4>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: 0, lineHeight: '1.5' }}>{item.path}</p>
                </div>
              ))}
            </div>

            <div style={{
              background: '#fef2f2',
              borderLeft: '4px solid #ef4444',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#991b1b', fontSize: '14px', margin: 0 }}>
                <strong>⚠️ Note:</strong> Disabling essential cookies may prevent you from using our platform.
              </p>
            </div>
          </div>

          {/* Section 5 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              5. Third-party cookies
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '12px' }}>
              We use <strong>Google Analytics</strong> to understand how visitors use our website. Google may set
              cookies on your device. See{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>
                Google's privacy policy
              </a>{' '}
              for more information.
            </p>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              You can opt out of Google Analytics by installing the{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>
                Google Analytics Opt-out Browser Add-on
              </a>.
            </p>
          </div>

          {/* Section 6 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              6. Changes to this policy
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              We may update this Cookie Policy from time to time. Changes will be posted on this page.
            </p>
          </div>

          {/* Contact bölümü */}
          <div style={{
            background: '#f8fafc',
            borderRadius: '12px',
            padding: '24px',
            marginTop: '40px',
            textAlign: 'center'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1e1b4b', margin: '0 0 8px' }}>
              Questions about cookies?
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 16px' }}>
              Contact our team at <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a>
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              background: '#6366f1',
              color: 'white',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500
            }}>
              ← Back to Home
            </Link>
          </div>

        </div>
      </div>

      <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default CookiePolicy;
